import { getDateForAttendee } from '@eventbrite/event-date-time';
import { connect } from 'react-redux';
import {
    getAppLocale,
    getCurrencyFormat,
    getIsAppRebrandActive,
} from '../../selectors/app';
import {
    getEventImageSrc,
    getEventStartDate,
    getEventTitle,
    getIsEventOnline,
} from '../../selectors/event';
import { getTimezone } from '../../selectors/infiniteCalendarSeries/infiniteCalendarSeries';
import { getCurrencyFromOrder } from '../../selectors/order/typedOrderSelectors';
import { getDisplayCostProps } from '../../selectors/tickets/getDisplayCostProps';
import { CheckoutState } from '../../state';
import { formatDateTime } from '../../utils/date';
import EventInfoCard from './EventInfoCard';

export const mapStateToProps = (state: CheckoutState) => {
    const eventStartDate = getEventStartDate(state);
    const isOnlineEvent = getIsEventOnline(state);
    const currency = getCurrencyFromOrder(state);
    const { totalCostUnformatted } = getDisplayCostProps(state);
    const locale = getAppLocale(state).replace('_', '-');
    const timezone = getTimezone(state);

    const date = getDateForAttendee({
        isOnlineEvent,
        dateAndTimezone: eventStartDate,
    }).toDate();

    return {
        eventTitle: getEventTitle(state),
        eventImageSrc: getEventImageSrc(state),
        eventDate: formatDateTime(date, { locale: locale, timeZone: timezone }),
        isOnlineEvent,
        currency,
        totalCostUnformatted,
        currencyFormat: getCurrencyFormat(state) || '',
        isAppRebrandActive: getIsAppRebrandActive(state),
    };
};

export const ConnectedEventInfoCard = connect(mapStateToProps)(EventInfoCard);

export default ConnectedEventInfoCard;
